export enum APP_LINKS {
  LOGIN = '/login',
  SIGNUP = '/signup',
  HOME = '/',
  NOT_FOUND = '/404',
  SETTINGS = 'settings',
  // PROFILE LINKS
  PROFILE_EDIT = 'edit',
  PROJECTS = 'projects',
  PROFILE_PROJECTS = 'projects',
  PROFILE_HIGHLIGHTS = 'highlights',
  PROFILE_NETWORK = 'network',
  PROFILE_CONNECTIONS = 'connections',
  PROFILE_MUTUAL_CONNECTIONS = 'mutual',
  PROFILE_COLD_PROFILE = 'cprofile',
  CHECKOUT = '/checkout',
}

export enum EXTERNAL_LINKS {
  CATALOG = 'https://catalog.creatorland.com',
  NETWORK_BUILDER_SERVICE_APPLY = 'https://ho4rn5p6amc.typeform.com/to/ZCreU3d9#email=',
  NETWORK_BUILDER_SERVICE_LEARN_MORE = 'https://docs.google.com/presentation/d/19VZrQnLyB5z_TCCVX6WqI-yQDMwW-dMcAoqCkDUHiJk/edit#slide=id.g248fdf6d497_0_0',
  SUPERCHARGE_LEARN_MOER = 'https://docs.google.com/presentation/d/19VZrQnLyB5z_TCCVX6WqI-yQDMwW-dMcAoqCkDUHiJk/edit#slide=id.g248fdf6d497_0_0',
  SUPERCHARGE_TYPEFORM = 'https://ho4rn5p6amc.typeform.com/supercharge?typeform-source=github.com#email=',
  AUTOMATE_RECRUITING = 'https://docs.google.com/presentation/d/1tWThyyITq47TuwkH4L9zFPF_BTSXF_0xtdC257Kzlqs/edit#slide=id.g27064926da3_0_0',
}

export const joinWithSlash = (...args: string[]) => {
  let url = args.join('/')
  // add first / if not present
  if (!url.startsWith('/')) {
    url = `/${url}`
  }
  // remove trailing slash
  if (url.endsWith('/')) {
    url = url.slice(0, -1)
  }
  return url
}

export const joinWithSlashExternal = (...args: string[]) => {
  let url = args.join('/')

  // remove first / if present
  if (url.startsWith('/')) {
    url = url.slice(1)
  }
  // remove trailing slash
  if (url.endsWith('/')) {
    url = url.slice(0, -1)
  }

  return url
}

export const linkWithParams = (
  link: string,
  params: Record<string, string | number>
) => {
  const paramsString = Object.entries(params)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .filter(([_, value]) => {
      return value !== undefined && value !== null
    })
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  return `${link}?${paramsString}`
}

type QueryObject = {
  [key: string]: string | number | boolean | Array<string | number>
}

export const objectToParams = (obj: QueryObject): string => {
  const params: string[] = []

  for (const key in obj) {
    const value = obj[key]

    if (Array.isArray(value)) {
      // Handle array values
      for (const item of value) {
        // Check if value exists and is not null and is not undefined
        if (item !== null && item !== undefined) {
          params.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`)
        }
      }
    } else {
      // Check if value exists and is not null and is not undefined
      if (value !== null && value !== undefined) {
        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      }
    }
  }

  return params.join('&')
}
